<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <employee-claims-approve-on-behalf-table-list :employee-uid="employee.employee_uid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeClaimsApproveOnBehalfTableList: () => import('@/components/employee/claims/approve-on-behalf/TableList'),
    },
    metaInfo () {
      return {
        title: 'Claim Approve On Behalf',
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
